define("vimeo/vimeo-wrapper",["vimeo"],function(e){"use strict";window.Vimeo=window.Vimeo||{Player:e}});
